<template>
  <div style="margin-bottom: 4.5rem;">
    <div class="container" style="margin: auto;">
      <div class="section breadcrumb mb-0">
        <div v-if="$route.query.consultant"
          class="is-clickable is-flex colour-secondary-01 is-underlined bold-l2 back-to-article"
          @click="$router.push('/consultant/' + (category == 'Trainings' ? 'upcoming-training' : category == 'Events' || category == 'Webinars' ? 'events-webinar' : 'campaign'))">
          <b-icon icon="menu-left" custom-size="is-large" style="font-size: 30px;"></b-icon>
          <span>Back to {{ category == 'Trainings' ? 'Trainings' : category == 'Campaigns' ? 'Campaigns' : category ==
            'Events' || category == 'Webinars' ? 'Events & Webinars' : '' }}</span>
        </div>
        <div v-else class="is-clickable is-flex colour-secondary-01 is-underlined bold-l2 back-to-article"
          @click="category == 'Trainings' ? $router.push('/happenings/training') : category == 'Campaigns' ? $router.push('/happenings/campaigns') : category == 'Events' ? $router.push('/happenings/events') : $router.push('/happenings/webinars')">
          <b-icon icon="menu-left" custom-size="is-large" style="font-size: 30px;"></b-icon>
          <span>Back to {{ category == 'Trainings' ? 'Trainings' : category == 'Campaigns' ? 'Campaigns' : category ==
            'Events' ? 'Events' : 'Webinars' }}</span>
        </div>
        <!-- Breadcrumbs -->
        <div class="pl-0 py-0 ml-2 mr-2 pl-0">
          <b-breadcrumb v-if="$route.query.consultant" align="is-left">
            <b-breadcrumb-item tag='router-link' to="/consultant/home">Consultant Home</b-breadcrumb-item>
            <b-breadcrumb-item tag='router-link'
              :to="'/consultant/' + (category == 'Trainings' ? 'upcoming-training' : category == 'Events' || category == 'Webinars' ? 'events-webinar' : 'campaign')">{{
                category == 'Events' || category == 'Webinars' ? 'Events & Webinars' : category }}</b-breadcrumb-item>
            <b-breadcrumb-item active v-if="course.attributes"> {{ course.attributes.title }}</b-breadcrumb-item>
          </b-breadcrumb>
          <b-breadcrumb v-else align="is-left">
            <b-breadcrumb-item tag='router-link' to="/happenings">Happenings</b-breadcrumb-item>
            <b-breadcrumb-item tag='router-link'
              :to="'/happenings/' + (category == 'Trainings' ? 'training' : category == 'Campaigns' ? 'campaigns' : category == 'Events' ? 'events' : 'webinars')">{{
                category }}</b-breadcrumb-item>
            <b-breadcrumb-item active v-if="course.attributes"> {{ course.attributes.title }}</b-breadcrumb-item>
          </b-breadcrumb>
        </div>
      </div>
      <div v-if="course.attributes" style="margin: auto;" class="section pt-0">
        <div class="columns is-12 pb-0 ml-mobile-0">
          <div class="column is-5-desktop mr-2">
            <div v-if="course.attributes.image" class="image is-square course-image">
              <img
                :src="course.attributes.image.data ? course.attributes.image.data.attributes.url : require('@/assets/img/default_photo_big.jpg')"
                style="min-height:300px;min-width:300px; object-fit: cover">
            </div>
          </div>
          <div class="column is-7-desktop has-text-left">
            <p class="pb-description colour-primary-02 bold-l2 mb-4">{{ category == 'Training' ? 'Training Details' :
              category == 'Event' ? 'Event Details' : category == 'Webinar' ? 'Webinar Details' : category == 'Campaign' ?
                'Campaign Details' : '' }}</p>
            <h1 class="pb-title">{{ course.attributes.title }}</h1>
            <div class=" mt-5">
              <div class="pb-subtitle">Date: {{ formatDate(course.attributes.date) }}</div>
              <div class="pb-subtitle">Time: {{ formatTime(course.attributes.start, course.attributes.end) }}</div>
              <div v-if="category == 'Campaigns'" class="pb-subtitle">Campaign Period: {{ course.attributes.registration_start &&
                course.attributes.registration_end ?
                formatDateRange(course.attributes.registration_start, course.attributes.registration_end) : '' }} </div>
              <div v-else class="pb-subtitle">Registration opening: {{ course.attributes.registration_start &&
                course.attributes.registration_end ?
                formatDateRange(course.attributes.registration_start, course.attributes.registration_end) : '' }} </div>
              <div class="pb-subtitle">CPD Points: {{ course.attributes.cpdPoint && course.attributes.cpdPoint != 0 ?
                course.attributes.cpdPoint : "N/A" }}</div>
              <div class="mt-5" v-html="course.attributes.content"></div>
              <div class="mt-5" v-if="isAuthenticated === true && category != 'Campaigns'">{{ 'Open to ' + (course.attributes.targetUser == 'Managing Partner' ? 'Managing Partner only' : course.attributes.targetUser == 'Public' || course.attributes.targetUser == 'For consultants only' || course.attributes.targetUser == 'all consultants' ? 'all consultants' : course.attributes.targetUser ?
                course.attributes.targetUser + ' and higher only' : 'all consultants') }}.
              </div>
              <div v-show="category != 'Campaigns'">
                <div v-if="isRegistered" class="mt-5" style="display: flex;">
                  <a style="color:#730039;" v-if="course.attributes.video_link"
                    :href="course.attributes.video_link.startsWith('http') ? course.attributes.video_link : '//' + course.attributes.video_link"
                    target="_blank">
                    <a :href="course.attributes.video_link" class="bold-l2"
                      style="color:#730039 !important; text-decoration: underline;" target="_blank">Video Link</a>
                  </a>
                  <div style="color:#730039;" v-if="course.attributes.zoom_link && course.attributes.video_link"
                    class="ml-1 mr-1">/</div>
                  <a style="color:#730039;" v-if="course.attributes.zoom_link"
                    :href="course.attributes.zoom_link.startsWith('http') ? course.attributes.zoom_link : '//' + course.attributes.zoom_link"
                    target="_blank">
                    <a :href="course.attributes.zoom_link" class="bold-l2"
                      style="color:#730039 !important; text-decoration: underline;" target="_blank">Zoom Link</a>
                  </a> 
                </div>
                <div v-if="dateExpired(course.attributes.date)" class="mt-3">
                  <div v-if="periodRange(course.attributes.registration_start, course.attributes.registration_end)">
                    <div v-if="!isRegistered" >
                      <div v-if="course.attributes.external_links">
                        <b-button type="" class="button dark-red join-now-btn"
                          @click="goToExternalLink(course.attributes.external_links)" :disabled="!isAuthenticated ? false : (course.attributes.targetUser == 'Managing Partner' ? ($store.state.user.ranking == 'MP' ? false : true) :
                            (course.attributes.targetUser == 'Senior Wealth Partner' ? ($store.state.user.ranking == 'MP' || $store.state.user.ranking == 'SWP' ? false : true) :
                              (course.attributes.targetUser == 'Wealth Manager' ? ($store.state.user.ranking == 'MP' || $store.state.user.ranking == 'SWP' || $store.state.user.ranking == 'WM' ? false : true) :
                                (course.attributes.targetUser == 'Wealth Associate' ? ($store.state.user.ranking == 'MP' || $store.state.user.ranking == 'SWP' || $store.state.user.ranking == 'WM' || $store.state.user.ranking == 'WA' ? false : true) :
                                  false))))">
                          <div>Register <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                        </b-button>
                      </div>
                      <div v-else>
                        <b-button v-if="isAuthenticated" type="" class="button dark-red"
                          @click="viewDetails(course.attributes.date, course.attributes.uuid)">
                          <div>Register <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                        </b-button>
                        <b-button v-else type="" class="button dark-red"
                          @click="$router.push({name:'course-registration-form',  query: {courseId: course.attributes.uuid}})">
                          <div>Register <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                        </b-button>
                      </div>
                    </div>
                    <div v-else class="is-align-items-center" style="display:flex;margin-bottom:10px;padding-top:5px;">
                      <div style="margin-left:0px;margin-top:10px;">
                        <img src="@/assets/icons/Approved.svg" style="height:24px;width:24px;">
                      </div>
                      <div class="ml-2 bold-l2">
                        Registration Approved
                      </div>
                      <div class="ml-5 pb-subtitle-3">
                        *You have registered for this training.
                      </div>
                    </div>
                  </div>
                  <div v-else class="is-flex is-align-items-center mt-5" >
                    <b-button type="" class="button dark-grey">
                      <div>Register <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                    </b-button>
                    <!-- <div class="pb-caption ml-5" style="max-width: 530px;">
                      *Registration period is over, you cannot register now, If you have any questions, please contact {{category }} host: 
                      <span style="text-decoration: underline !important">AHAM Curiosity Corner</span>
                    </div> -->
                  </div>
                </div>
                <div v-else class="is-flex is-align-items-center mt-5">
                  <b-button type="" class="button dark-grey">
                    <div>Register <b-icon class="ml-1" icon="play" size="is-small"></b-icon></div>
                  </b-button>
                  <!-- <div class="pb-caption ml-5" style="max-width: 530px;">
                    *{{category.slice(0,-1) }} is over, you cannot register now, If you have any questions, please contact {{ category.slice(0,-1).toLowerCase() }} host: 
                    <span style="text-decoration: underline !important">AHAM Curiosity Corner</span>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-loading :is-full-page="true" v-model="isLoading">
      <b-icon pack="mdi" icon="loading" size="is-large" custom-class="mdi-spin">
      </b-icon>
    </b-loading>

    <div class="is-flex is-justify-content-end">
      <ScrollTop />
    </div>

    <!-- Modal (hidden) -->
    <b-modal v-model="isModalActive" :can-cancel="false" style="padding: 0 1rem;">
      <div class="modal-card" style="margin: auto;">
        <header class="modal-card-head pt-2 pb-2 pl-2 pr-2 modal-header"
          style="background: #730039; border-radius: 0px; height: 50px;">
          <p class="modal-card-title"></p>
          <b-button class="close-btn" style="background: transparent !important;" @click="isModalActive = false"><b-icon
              icon="close" style="color:#FFFFFF; cursor: pointer; height: 100%"></b-icon></b-button>
        </header>

        <div class="modal-card-body pl-5 pr-5 pt-5 pb-5">
          <div class="has-text-centered">
            <div class="pop-up-text">
              <div class="pl-4 pr-4" style="color: #363636;">This {{ category.toLowerCase().slice(0,-1)  }} is only available for AHAM
                Wealth Partners registered consultants. To register, please <span @click="login"
                  style="color: #3DBB95 !important; text-decoration: underline !important; cursor: pointer;">login
                  here</span> or <span @click="$router.push('/contact-us')"
                  style="color: #3DBB95 !important; text-decoration: underline !important; cursor: pointer;">get in touch
                  with us</span> to understand more.</div>
              <hr class="divider">
              <div class="">
                <div class="wrapper-contact">
                  <div>
                    <a href="tel:+1-800-22-2288" class="is-flex is-align-items-center">
                      <img class="mr-2 has-text-left" src="@/assets/icons/pop-up-call.svg" />
                      <span class="colour-text">Tel: 1800-22-2288</span>
                    </a>
                  </div>
                  <div>
                    <a href="mailto:parasupport@aham.com.my" class="is-flex is-align-items-center">
                      <img class="mr-2 has-text-left" src="@/assets/icons/email.png" />
                      <a href="mailto:parasupport@aham.com.my" target="_self"
                        class="colour-text">parasupport@aham.com.my</a>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- modal (hidden)-->
    <b-modal v-model="isConfirm" style="padding: 0 1rem;">
      <div class="modal-card" style="margin: auto;">
        <header class="modal-card-head pt-2 pb-2 pl-2 pr-2 modal-header"
          style="background: #730039; border-radius: 0px; height: 50px;">
          <p class="modal-card-title"></p>
          <b-button class="close-btn" style="background: transparent !important;" @click="isConfirm = false"><b-icon
              icon="close" style="color:#FFFFFF; cursor: pointer; height: 100%"></b-icon></b-button>
        </header>

        <div class="modal-card-body pl-5 pr-5 pt-5 pb-5">
          <div class="has-text-centered">
            <div class="pop-up-text">
              <p class="pl-5 pr-5" style="color: #363636;">Would you like to secure your spot for this {{
                category.toLowerCase().slice(0,-1)  }}?</p>
              <br>
              <div class="">
                <b-button class="pl-6 pr-6 mr-5" style="color:#730039;border:1px solid #730039;background-color: white;"
                  @click="isConfirm = false">No</b-button>
                <b-button class="button dark-red pl-6 pr-6" @click="register(modalDate, modalUuid)">Yes</b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <!-- Modal (hidden) -->
    <b-modal v-model="registerSuccess" style="padding: 0 1rem;">
      <div class="modal-card" style="margin: auto;">
        <header class="modal-card-head pt-2 pb-2 pl-2 pr-2 modal-header"
          style="background: #730039; border-radius: 0px; height: 50px;">
          <p class="modal-card-title"></p>
          <b-button class="close-btn" style="background: transparent !important;" @click="refreshData()"><b-icon
              icon="close" style="color:#FFFFFF; cursor: pointer; height: 100%"></b-icon></b-button>
        </header>

        <div class="modal-card-body pl-5 pr-5 pt-5 pb-5">
          <div class="has-text-centered">
            <div class="pop-up-text">
              <p class="pl-5 pr-5" style="color: #363636;">You have successfully registered for the {{
                category.toLowerCase().slice(0,-1)  }}.</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>


  </div>
</template>

<script>
import dayjs from 'dayjs';
import router from '../router';
import ScrollTop from '../components/ScrollTop.vue';

export default {
  data() {
    const shortMonths = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    return {
      shortMonths,
      course: {},
      enrollList: [],

      isConfirm: false,
      modalDate: '',
      modalUuid: '',
      registerSuccess: false,
      isLoading: false,
      isModalActive: false,
      isRegistered: false,
      category: '',
    };
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters['auth/isAuthenticated']
    },
  },
  methods: {
    refreshData() {
      this.registerSuccess = false
      this.fetchData();

    },
    goToExternalLink(ext_link) {
      window.open(ext_link, '_blank', 'popup=1');
    },
    formatDateRange(startDate, endDate) {
      // Convert the date strings to Date objects
      startDate = new Date(startDate);
      endDate = new Date(endDate);

      // Format the start and end dates
      const startFormatted = `${startDate.getDate()} ${this.shortMonths[startDate.getMonth()]} ${startDate.getFullYear()}`;
      const endFormatted = `${endDate.getDate()} ${this.shortMonths[endDate.getMonth()]} ${endDate.getFullYear()}`;

      // Check if the dates are in different months or years
      if (startDate.getFullYear() !== endDate.getFullYear()) {
        return `${startFormatted} - ${endFormatted}`;
      } 
      else if (startDate.getMonth() !== endDate.getMonth() && startDate.getFullYear() == endDate.getFullYear()) {
        return `${startDate.getDate()} ${this.shortMonths[startDate.getMonth()]} - ${endDate.getDate()} ${this.shortMonths[endDate.getMonth()]} ${endDate.getFullYear()}`;
      }
      else {
        return `${startDate.getDate()} - ${endDate.getDate()} ${this.shortMonths[startDate.getMonth()]} ${startDate.getFullYear()}`;
      }
    },
    login() {
      this.$store.dispatch('auth/login');
    },
    periodRange(startDate, endDate) {
      let today = new Date()
      let nStartDate = new Date(startDate)
      let nEndDate = new Date(endDate)
      nEndDate.setDate(nEndDate.getDate() + 1)

      //if today is between start and end date
      if (today.getTime() >= nStartDate.getTime() && today.getTime() <= nEndDate.getTime()) {
        return true
      }
      else {
        return false
      }
    },
    viewDetails(dataDate, dataUuid) {
      if (this.isAuthenticated) {
        this.isConfirm = true;
        this.modalUuid = dataUuid;
        this.modalDate = dataDate;
      } else {
        this.isModalActive = true;
      }
    },
    dateExpired(apiDate) {
      let today = new Date()
      let dataDate = new Date(apiDate)

      if (dataDate.getTime() < today.getTime()) {
        return false
      }
      else {
        return true
      }
    },
    formatDate(date) {
      let tempDate = new Date(date);
      let day = tempDate.getDate();
      let month = this.shortMonths[tempDate.getMonth()];
      let year = tempDate.getFullYear();

      let formattedDateTime = day + " " + month + " " + year;
      return formattedDateTime;
    },
    formatTime(start, end) {
      //start time
      const tempDate1 = new Date();
      tempDate1.setHours(start.slice(0, 2));
      tempDate1.setMinutes(start.slice(3, 5));

      let startAmpm = (tempDate1.getHours() < 12) ? "AM" : "PM"
      let startHour = tempDate1.getHours() % 12;
      let startMinute = tempDate1.getMinutes();

      if (startHour == 0) {
        startHour = 12;
      }
      // startHour = ("0" + startHour).slice(-2);
      startMinute = ("0" + startMinute).slice(-2);

      //end time
      const tempDate2 = new Date();
      tempDate2.setHours(end.slice(0, 2));
      tempDate2.setMinutes(end.slice(3, 5));

      let endAmpm = (tempDate2.getHours() < 12) ? "AM" : "PM"
      let endHour = tempDate2.getHours() % 12;
      let endMinute = tempDate2.getMinutes();

      if (endHour == 0) {
        endHour = 12;
      }
      // endHour = ("0" + endHour).slice(-2);
      endMinute = ("0" + endMinute).slice(-2);

      let formattedDate = startHour + ":" + startMinute + startAmpm + " - " +
        endHour + ":" + endMinute + endAmpm;
      return formattedDate;
    },
    formatDescription(programType, hostContact) {
      if (programType === undefined) {
        programType = "Training";
      }
      else {
        programType = programType.charAt(0).toUpperCase() + programType.slice(1); // capitalize first letter in a string
      }
      if (hostContact !== "") {
        return programType + " is over, you cannot register now. If you have any questions, please contact " + programType + " host: ";
      }
      return programType + " is over, you cannot register now.";
    },
    register(date, courseId) {
      this.isConfirm = false;
      this.isLoading = true
      //if consultant
      if (this.isAuthenticated) {
        this.fullname = this.$store.state.user.name
        this.email = this.$store.state.user.email
        // POST to endpoint (consultant)
        let month = dayjs(date).month() + 1;
        let year = dayjs(date).year();
        let startDate = year + '-' + month + '-01';
        let end = dayjs(startDate).daysInMonth();     // number of days in a month (28-31)
        let endDate = year + '-' + month + '-' + end;
        this.$httpClient({
          method: "GET",
          url: "/pbmicrosite/enroll/" + this.$store.state.user.uuid + "?startdate=" + startDate + "&enddate=" + endDate,
        }).then((resp) => {
          let enroll = resp.data.filter(i => i.CourseId === courseId.toString());
          if (enroll.length > 0) {
            this.$buefy.toast.open({
              message: 'This course is registered',
              type: 'is-danger'
            })
            this.registerSuccess = false;
            this.isLoading = false
          } else {
            // POST to endpoint
            this.$httpClient.post("/pbmicrosite/register/" + courseId,
              {
                ParticipantId: this.$store.state.user.uuid.toString(),
                ParticipantType: 1,
                Fullname: this.fullname.toString(),
                Email: this.email.toString()
              })
              .then(resp => {
                if (resp.data.EnrollStatus === true) {
                  // this.$buefy.toast.open({
                  //   message: 'You have successfully registered into the course',
                  //   type: 'is-success'
                  // })

                  //popup modal success
                  this.registerSuccess = true;
                  this.isLoading = false
                }
              })
              .catch((error) => {
                this.$buefy.toast.open({
                  message: 'This course is full, registration denied',
                  type: 'is-danger'
                })
                this.registerSuccess = false;
                this.isLoading = false
              });
          }
        });
      }
      //if public
      else {
        // POST to endpoint (public)
        this.$httpClient.post("/internal/pbmicrosite/register/" + courseId,
          {
            ParticipantType: 0,
            PbNric: this.nric.toString(),
            PbFirstname: this.firstname.toString(),
            PbLastname: this.lastname.toString(),
            PbFullname: this.fullname.toString(),
            PbEmail: this.email.toString(),
            PbPhoneno: this.phone.toString()
          })
          .then(resp => {
            if (resp.data.EnrollStatus === true) {
              this.$buefy.toast.open({
                message: 'You have successfully registered into the course',
                type: 'is-success'
              })
              location.reload();
            }
          })
          .catch((error) => {
            this.$buefy.toast.open({
              message: 'This course is full, registration denied',
              type: 'is-danger'
            });
            this.registerSuccess = false;
            this.modalActive = false;
          });
      }
    },
    getEnrollList() {
      let today = dayjs();
  let startDate = today.format('YYYY-MM-DD');
  this.$httpClient({
    method: "GET",
    url: "/pbmicrosite/enroll/" + this.$store.state.user.uuid + "?startdate=" + startDate,
      }).then((resp) => {
        this.$set(this, "enrollList", resp.data);
        let enroll = this.enrollList.filter(i => i.CourseId === this.$route.query.courseId);

        if (enroll.length > 0) {
          this.isRegistered = true
        }
        else {
          this.isRegistered = false
        }

      });
    },
    checkRegisterLabel(programId) {
      if (this.isAuthenticated) {
        let enroll = this.enrollList.filter(i => i.CourseId === programId);
        if (enroll.length > 0) {
          return "REGISTERED";
        }
        else {
          return "Register";
        }
      }
      return "Register";
    },
    checkRegisterIcon(programId) {
      if (this.isAuthenticated) {
        let enroll = this.enrollList.filter(i => i.CourseId === programId);
        if (enroll.length > 0) {
          return "check";
        }
        else {
          return "play";
        }
      }
      return "play";
    },
    fetchData(){
      this.$httpClientCMS({
      method: "GET",
      url: "api/trainings?populate=*&filters[uuid][$eq]=" + this.$route.query.courseId
    })
      .then(resp => {
        this.course = resp.data.data[0] ? resp.data.data[0] : this.course;
        this.isLoading = false;
        if (resp.data.data.length > 0) {
          this.category = 'Trainings'
          if (this.$store.getters['auth/isAuthenticated']) {
            this.getEnrollList()
          }
        }



      });
    this.$httpClientCMS({
      method: "GET",
      url: "api/events?populate=*&filters[programType][$eq]=event&filters[uuid][$eq]=" + this.$route.query.courseId
    })
      .then(resp => {
        this.course = resp.data.data[0] ? resp.data.data[0] : this.course;
        this.isLoading = false;
        if (resp.data.data.length > 0) {
          this.category = 'Events'

          if (this.$store.getters['auth/isAuthenticated']) {
            this.getEnrollList()
          }
        }

        this.isLoading = false;

      });
    this.$httpClientCMS({
      method: "GET",
      url: "api/events?populate=*&filters[programType][$eq]=webinar&filters[uuid][$eq]=" + this.$route.query.courseId
    })
      .then(resp => {
        this.course = resp.data.data[0] ? resp.data.data[0] : this.course;
        this.isLoading = false;
        if (resp.data.data.length > 0) {
          this.category = 'Webinars'

          if (this.$store.getters['auth/isAuthenticated']) {
            this.getEnrollList()
          }
        }

        this.isLoading = false;
      });

    this.$httpClientCMS({
      method: "GET",
      url: "api/campaigns?populate=*&filters[uuid][$eq]=" + this.$route.query.courseId
    })
      .then(resp => {
        this.course = resp.data.data[0] ? resp.data.data[0] : this.course;
        this.isLoading = false;
        if (resp.data.data.length > 0) {
          this.category = 'Campaigns'

          if (this.$store.getters['auth/isAuthenticated']) {
            this.getEnrollList()
          }
        }

        this.isLoading = false;
      });
    }
  },
  mounted() {


    this.isLoading = true;
    this.fetchData();
   

  },
  components: { router, ScrollTop }
}
</script>

<style lang="scss" scoped>
@import './styles/font.scss';

.section-spacing {
  padding-left: 95px !important;
  padding-right: 60px !important;
}

.wrapper-contact {
  display: flex;
  justify-content: space-around;
}

.section.breadcrumb {
  padding: 2.5rem 0 2rem;

  .back-to-article {
    padding-bottom: 1.5rem;
  }
}

.image {
  margin-left: auto;
  margin-right: auto;
}

.button.dark-grey {
  color: #FFFFFF;
  background-color: #D8D8D8;
}

.button {
  &:focus {
    box-shadow: none !important;
  }
}


.is-divider {
  height: 1px;
}

.title {
  font-size: 16px;
  text-align: left;
}

.content {
  text-align: left;
  font-weight: 600;
}

.contentDescrip {
  font-size: 15px;
  text-align: left;
}

.course-image {
  width: 100%;
  max-width: 630px;
  // height: 100%;
  object-fit: cover;
}

// .image.is-square{
//   padding-top: 0%;
// }

.pb-title {
  margin-top: 0.5rem;
}

.pb-subtitle {
  font-weight: 400;
}

.description {
  text-align: left;
  font-size: 14px;
}

.notification {
  background-color: #DEDEDE !important;
}

.button-icon-text-v1 {
  font-size: 1rem;
  text-decoration: none;
  border: none;
  background-color: #730039;
  color: #FFF;
}

@media screen and (max-width:1290px) and (min-width: 1022px) {
  .section-spacing {
    padding-left: 40px !important;
    padding-right: 20px !important;
  }
}

@media screen and (max-width: 1023px) {
  .section-spacing {
    padding-left: 5px !important;
    padding-right: 0px !important;
  }

  :deep() {
    .breadcrumb {

      // margin-right: 10rem;
      ul {
        padding-left: 0 !important;
        flex-wrap: wrap !important;
      }

      li {
        white-space: break-spaces;

        &.is-active {
          align-items: flex-start;

          a {
            text-align: left;
            padding: 0;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .section-spacing {
    padding-left: 0px !important;
    padding-right: 0px !important;
  }

  .course-container {
    display: flex;
    flex-direction: column;
  }

  .course-image {
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: 342px;
    object-fit: cover;
  }

  .ml-mobile-0 {
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }

  .wrapper-contact {
    display: block;
    text-align: center;

    a {
      padding: 0.3rem 0;
      justify-content: center !important;
    }
  }
}

@media screen and (max-width:425px) {
  .description {
    padding-left: 15px;
    padding-right: 15px;
  }
}

@media screen and (max-width:374px) {
  .course-image {
    img {
      min-width: 100px !important;
      min-height: 100px !important;
    }
  }
}</style>
